import { confidenceClass, confidenceLabel } from "../lib/format";

export default function ConfidenceBadge({ value, showValue = true, testid }) {
  const cls = confidenceClass(value);
  const label = confidenceLabel(value);
  const pct = value === null || value === undefined ? "—" : `${Math.round(value * 100)}%`;
  return (
    <span
      className={`pxos-badge ${cls}`}
      data-testid={testid || "confidence-badge"}
      data-confidence={value ?? "null"}
    >
      <span aria-hidden>●</span> {label}{showValue ? ` · ${pct}` : ""}
    </span>
  );
}
